import { render, staticRenderFns } from "./FooterConsentTab.vue?vue&type=template&id=4889690d&scoped=true"
import script from "./FooterConsentTab.vue?vue&type=script&lang=js"
export * from "./FooterConsentTab.vue?vue&type=script&lang=js"
import style0 from "./FooterConsentTab.vue?vue&type=style&index=0&id=4889690d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4889690d",
  null
  
)

export default component.exports